/**
 * User-facing copy for Firebase Auth error codes.
 * Mirrored in american-drone-network-web — keep both copies in sync.
 */
const FIREBASE_AUTH_MESSAGES: Record<string, string> = {
  'auth/invalid-credential': 'Invalid email or password.',
  'auth/invalid-email': 'Invalid email address.',
  'auth/user-disabled': 'This account has been disabled.',
  'auth/user-not-found': 'No account found with this email.',
  'auth/wrong-password': 'Incorrect password.',
  'auth/email-already-in-use': 'An account with this email already exists.',
  'auth/weak-password': 'Password must be at least 6 characters.',
  'auth/too-many-requests': 'Too many attempts. Please wait a few minutes and try again.',
  'auth/network-request-failed': 'Network error. Please check your connection.',
  'auth/invalid-action-code': 'This link is invalid or has already been used. Request a new one.',
  'auth/expired-action-code': 'This link has expired. Request a new one.',
  'auth/invalid-verification-code': 'That code is incorrect. Please try again.',
  'auth/code-expired': 'That code has expired. Please request a new one.',
  'auth/invalid-phone-number': 'Please enter a valid phone number.',
};

/** Readable message for a Firebase Auth error, or `fallback` for unmapped codes. */
export function firebaseErrorMessage(error: unknown, fallback = 'Something went wrong. Please try again.'): string {
  const code = (error as { code?: string })?.code;
  return (code && FIREBASE_AUTH_MESSAGES[code]) || fallback;
}
